"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _image = require("@site/pattern-library-core/image");
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c1u5u905"
});
const Anchor = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Anchor",
  class: "pl-a1fageqm"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ImageContainer",
  class: "pl-i1kc5gl0"
});
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ContentContainer",
  class: "pl-chila8r"
});

/**
 * CoMarketingBar Component.
 *
 * Renders a promotional bar with an image, title, description, and optional tag.
 *
 * @param {Object} props - React props
 * @param {string} props.id - Identifier
 * @param {string} props._name - Tracking Name
 * @param {Object} props.image - Image Properties
 * @param {string} props.image.url - Image URL
 * @param {string} props.image.altText - Image Alt Text
 * @param {string|number} props.image.height - Image Height
 * @param {string|number} props.image.width - Image Width
 * @param {string} props.title - Title Text / Pricing Tokens
 * @param {string} props.description - Description Text
 * @param {string} props.link - Anchor Link URL
 * @param {string} props.tagLabel - Tag Label Text
 * @param {string} props.labelDesign - Tag Label Design
 * @param {boolean} props.openInNewWindow - Open Link in New Window
 * @param {Object} props.style - React Style Object
 * @param {string} props.className - React Class Name
 * @param {string} props.ariaLabel - Aria Label for Accessibility
 * @returns {React.ReactElement} CoMarketingBar Component
 * @public
 */
function CoMarketingBar({
  id,
  _name,
  image = {},
  title,
  description,
  link,
  tagLabel,
  labelDesign,
  openInNewWindow = false,
  style,
  className,
  ariaLabel = 'co-marketing-link'
}) {
  const target = openInNewWindow ? {
    target: '_blank'
  } : {};
  const {
    url,
    altText,
    height,
    width
  } = image;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "co-marketing-space"
  }, /*#__PURE__*/_react.default.createElement(Anchor, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "co-marketing-anchor",
    href: link,
    ariaLabel: ariaLabel,
    className: className,
    style: style
  }, target, _patternLibraryUtils.tracking.create(_name, true, true)), /*#__PURE__*/_react.default.createElement(ImageContainer, null, url && /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    url: url,
    altText: altText,
    height: height,
    width: width
  })), /*#__PURE__*/_react.default.createElement(ContentContainer, null, tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tagLabel,
    design: labelDesign,
    size: "sm"
  }), title && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "title",
    size: 0,
    dataCy: "price-title",
    text: title
  }), description && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "paragraph",
    size: -2,
    dataCy: "description",
    text: description
  }))));
}
var _default = exports.default = CoMarketingBar;
CoMarketingBar.propTypes = {
  id: _propTypes.default.string.isRequired,
  _name: _propTypes.default.string,
  image: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string,
    height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  }),
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  link: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  openInNewWindow: _propTypes.default.bool,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  ariaLabel: _propTypes.default.string
};